import * as React from "react";
import { Item } from "devextreme-react/toolbar";
import { SelectBox } from "devextreme-react";

export function DropDown(key: string, options: {
    val: string | undefined, display: string
}[], selected: string | undefined, onSelectionChanged: (selected: string | undefined) => void, label?: string) {

    return [
        <Item location="before" key={key}
            locateInMenu="never"
            render={() => {
                return <div style={{ paddingLeft: 16 }}>
                    <SelectBox dataSource={options} label={label}
                        displayExpr='display'
                        valueExpr='val'
                        value={selected}
                        onValueChanged={(e) => {
                            onSelectionChanged((e.value))
                        }} />
                </div>
            }} />
    ]
}


// WEBPACK FOOTER //
// ./src/components/DropDown.tsx